// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1D9Uz","left":"StickyBox_left__1WY3u","right":"StickyBox_right__27bNO"};